import React, { Suspense, useState } from "react";
import styles from "./HomePage.module.scss";
import Image from "next/future/image";
import dynamic from "next/dynamic";
import Link from "next/link";

// Optimize image imports
import BlueHoleIcon from "../../../public/logo.png";
import secondBg from "../../assets/images/second-bg.png";
import forthBg from "../../assets/images/forth-bg.png";
const WhiteBackground = dynamic(
  () => import("src/assets/images/white-background-reversed.jpg"),
  {
    loading: () => <div className={styles.imagePlaceholder} />,
  },
);

// Optimize bootstrap imports
const Container = dynamic(() => import("react-bootstrap/Container"));
const Row = dynamic(() => import("react-bootstrap/Row"));
const Col = dynamic(() => import("react-bootstrap/Col"));
const Modal = dynamic(() => import("react-bootstrap/Modal"));

// Import styles after component mount
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
// components
const Spliter = dynamic(
  () => import("src/components/HomePage/Spliter/Spliter"),
);
const Testmonials = dynamic(
  () => import("src/components/HomePage/Testmonials/Testmonials.jsx"),
);
const NavigationBar = dynamic(
  () => import("src/components/shared/NavigationBar/NavigationBar"),
);
const BackgroundImageWithTextButtonRightImageLeft = dynamic(
  () =>
    import("src/components/HomePage/BackgroundImageWithTextButtonRightImageLeft/BackgroundImageWithTextButtonRightImageLeft"),
);
const BackgroundImageWithRightTextLeftButton = dynamic(
  () =>
    import("src/components/HomePage/BackgroundImageWithRightTextLeftButton/BackgroundImageWithRightTextLeftButton"),
);
const PriceList = dynamic(
  () => import("src/components/HomePage/PriceList/index.js"),
);
const Carousel = dynamic(
  () => import("src/components/HomePage/Carousel/carousel"),
);
const Footer = dynamic(() => import("src/components/shared/Footer/Footer"));
const CommonQuestions = dynamic(
  () => import("src/components/shared/CommonQuestions/CommonQuestions"),
);

import { useRouter } from "next/router";
import Head from "next/head";
import { FormattedMessage } from "react-intl";
import ReactBeforeSliderComponent from "react-before-after-slider-component";
import "react-before-after-slider-component/dist/build.css";
import Form from "src/components/ContacUsPage/Form/Form";
import { buildApiUrl } from "src/helpers/imageHelpers";
import { SwiperSlide, Swiper } from "swiper/react";
import { Autoplay, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

const HomePage = ({ data, appSetting, footerSettings }) => {
  const indexData = data?.indexData?.AppSetting;
  const galleryPosts = data?.galleryData?.[0]?.categories?.[0]?.posts;
  const partnerPosts = data?.partnerData?.[0]?.categories?.[0]?.posts;
  const bannerData = data?.bannerData?.[0]?.categories?.[0]?.posts;
  const benfitDataPosts = data?.benfitDataPosts?.[0]?.categories?.[0]?.posts;
  const benfitDataHeader = data?.benfitDataHeader?.[0]?.categories?.[0]?.posts;
  const splitersData = data?.splitersData?.[0]?.categories?.[0]?.posts;
  // const videoData = data?.videoData?.[0]?.categories?.[0]?.posts;
  const testmonialsData = data?.testmonialsData?.[0]?.categories?.[0]?.posts;
  const pricesData = data?.pricesData?.[0]?.categories?.[0];
  const questionsData = data?.questions?.[0]?.categories?.[0]?.posts;
  const router = useRouter();
  const { locale: lang } = router;
  const certificationsPost = data?.certificationsPost;
  const certificationsTitle = certificationsPost?.data?.title?.[lang];
  const certificationsItems = certificationsPost?.data?.certifications || [];
  const [lightboxImage, setLightboxImage] = useState(null);
  const dir = lang === "ar" ? "rtl" : "ltr";
  const isRtl = lang === "ar";


  const targetQuestion = questionsData?.find((question) => question.id === 416);
  const commonQuestionsBackgroundImage = targetQuestion?.data?.image;
  const filteredQuestions = questionsData?.filter(
    (question) => question.id !== 416,
  );

  const resolvedAppSetting = appSetting || indexData;

  const normalizeSettingValue = (value) =>
    typeof value === "string" ? value.replace(/`/g, "").trim() : "";

  const bannerCtaText = normalizeSettingValue(
    lang === "ar"
      ? resolvedAppSetting?.mainBannerCtaText
      : resolvedAppSetting?.mainBannerCtaText_EN ||
          resolvedAppSetting?.mainBannerCtaText,
  );
  const bannerCtaUrl = normalizeSettingValue(
    resolvedAppSetting?.mainBannerCtaUrl,
  );
  const isExternalBannerCtaUrl = /^https?:\/\//i.test(bannerCtaUrl);
  const contactMapHtml =
    footerSettings?.AppSetting?.ifameMap || indexData?.ifameMap || "";
  const contactFallbackImage =
    resolvedAppSetting?.fullbackMapImage || indexData?.fullbackMapImage || "";
  const hasContactMap = Boolean(contactMapHtml?.trim());
  const hasContactFallbackImage = Boolean(contactFallbackImage);
  const hasContactVisual = hasContactMap || hasContactFallbackImage;

  return (
    <>
      <NavigationBar HomePage />
      <div className={styles.background}>
        <Head>
          {/* Resource hints to speed up LCP image */}
          <link rel="preconnect" href={process.env.NEXT_PUBLIC_API_URL} />
          {/* next/future/image with `priority` will automatically preload the optimized image URL.
              Avoid manually preloading the original remote URL because Next's image
              optimizer serves a different URL (/_next/future/image?url=...) and the manual
              preload can produce the "preloaded but not used" warning. */}
        </Head>
        <section className={styles.banner} style={{}} >
          {/* <div
            style={{
    position: "absolute",
    inset: 0, 
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(270deg, rgba(14, 24, 31, 0.72) 0%, rgba(14, 24, 31, 0.576) 53.69%, rgba(14, 24, 31, 0.2304) 100%)",
  }} >
          </div> */}
          {appSetting?.mainBannerImage?.includes("mp4") ? (
            <video
              className={styles.videobcg}
              autoPlay={true}
              loop="loop"
              muted={true}
              // volume="0"
              preload="metadata"
            >
              <source
                src={`${process.env.NEXT_PUBLIC_API_URL}/${appSetting.mainBannerImage}#t=0.1`}
                type="video/mp4"
              />
              Sorry, your browser does not support HTML5 video.
            </video>
          ) : appSetting?.mainBannerImage ? (
            <Image
              src={`${process.env.NEXT_PUBLIC_API_URL}/${appSetting.mainBannerImage}`}
              width={1920}
              height={1000}
              alt="background"
              quality={75}
              sizes="100vw"
              priority
              fetchpriority="high"
            />
          ) : null}

          {/* <video
            className={styles.videobcg}
            autoPlay={true}
            loop="loop"
            muted={true}
            // volume="0"
            preload="metadata"
            poster={VideoPoster.src}
          >
            <source
              src={`${process.env.NEXT_PUBLIC_API_URL}${videoData?.[0]?.data?.image}#t=0.1`}
              type="video/mp4"
            />
            Sorry, your browser does not support HTML5 video.
          </video> */}

          <Container className="h-100">
            <div className={styles["background-text"]}>
              <h1>
                {lang === "ar" && data?.indexData?.AppSetting?.BannerTitle}
                {lang === "en" && data?.indexData?.AppSetting?.BannerTitle_EN}
              </h1>
              <h2>
                {lang === "ar" && data?.indexData?.AppSetting?.BannerDesc}
                {lang === "en" && data?.indexData?.AppSetting?.BannerDesc_EN}
              </h2>
              {bannerCtaText && bannerCtaUrl ? (
                isExternalBannerCtaUrl ? (
                  <a href={bannerCtaUrl} target="_blank" rel="noreferrer" className={styles["cta-button"]}>
                    {bannerCtaText}
                    <div 
                     style={{
              width: "40px",
              height: "40px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
                  background: "white",
                  borderRadius:"500px",

            }}
                    >
                        <svg
            style={{ transform: isRtl ? "none" : "scaleX(-1)" }}
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.53577 3.53556L14.1424 14.1422"
                  stroke="black"
                  strokeWidth={1.5}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553"
                  stroke="black"
                  strokeWidth={1.5}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

                    </div>
                  </a>
                ) : (
                  <Link href={bannerCtaUrl}>
                    <a className={styles["cta-button"]}>{bannerCtaText}</a>
                  </Link>
                )
              ) : null}
            </div>
          </Container>
        </section>
      </div>
      <Spliter
        primaryTitle={splitersData?.[0]?.data?.title?.[lang]}
        primaryText={splitersData?.[0]?.data?.description?.[lang]}
        secondaryTitle={splitersData?.[0]?.data?.title2?.[lang]}
        secondaryText={splitersData?.[0]?.data?.description2?.[lang]}
        image={splitersData?.[0]?.data?.image}
      />

        <div   
          style={{ backgroundImage: `url(${secondBg.src})`,backgroundColor:"#F0E3E3"
 }}
        >

 <Container
        
        className={styles["background-images"]}
      
      >
        <Row className="px-md-5">
          {bannerData?.map((post, index) => {
            const isForcedWhite = index === 0;
            const hasImage = isForcedWhite ? false : post?.data?.image;
            const bgImage = hasImage ? buildApiUrl(post?.data?.image) : null;

            const orders = () => {
              let order;
              index === 0
                ? (order = 2)
                : index === 1
                  ? (order = 1)
                  : index === 2
                    ? (order = 3)
                    : (order = 4);
              return order;
            };

            return (
              <Col
                lg={6}
                xs={{ span: 12, order: orders() }}
                className="p-3"
                key={index}
              >
                <div
                  className={`${styles["banner-card"]} ${hasImage ? styles["with-image"] : styles["without-image"]}`}
                  style={{
                    backgroundImage: bgImage ? `url(${bgImage})` : "none",
                  }}
                >
                  <div className={styles["card-content"]}>
                    <h2
                      className={styles["card-title"]}
                      dangerouslySetInnerHTML={{ __html: post?.data?.title?.[lang] || "" }}
                    />
                    <p
                      className={styles["card-description"]}
                      dangerouslySetInnerHTML={{ __html: post?.data?.description?.[lang] || "" }}
                    />
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>
        </div>
     

      {/* <Spliter
        primaryText={splitersData?.[1]?.data?.title?.[lang]}
        secondaryText={splitersData?.[1]?.data?.description?.[lang]}
      /> */}

      {/* <div className={styles["custom-head"]}>
        <Image
          src={BlueHoleIcon}
          alt=""
          className={styles.BlueHoleIcon}
          width={100}
          height={100}
        />
        <p>
          <FormattedMessage id="ourworks" />
        </p>
      </div>

      <div className={styles["grid-container"]} dir={dir}>
        <Container>
          <Row>
            {galleryPosts?.slice(0, 6)?.map((post, index) => {
              return (
                <Col xs={12} sm={6} lg={4} key={index}>
                  <div className="work-item">
                    <div className="content">
                      <ReactBeforeSliderComponent
                        firstImage={{
                          imageUrl: buildApiUrl(post?.data?.image),
                          alt: post?.data?.imageMeta || "work-image",
                        }}
                        secondImage={{
                          imageUrl: buildApiUrl(post?.data?.image_new),
                          alt: post?.data?.imageMeta_new || "work-image",
                        }}
                        delimiterIconStyles={{
                          width: "30px",
                          height: "30px",
                          backgroundImage: `url(${BlueHoleIcon.src})`,
                          backgroundPosition: "center",
                          backgroundSize: "contain",
                          backgroundRepeat: "no-repeat",
                        }}
                      />
                    </div>
                    <div className="desc">
                      <h3>{post?.data?.title?.[lang]}</h3>
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>

          <div className="mt-5 text-center">
            <Link href="/ourworks">
              <a className="btn">
                <FormattedMessage id="viewAll" />
              </a>
            </Link>
          </div>
        </Container>
      </div> */}

      {partnerPosts?.length > 0 && (
        <section className={styles.partners}  >
          <Container>
            <h2 className={styles.partnersTitle}>
              <FormattedMessage id="success-partners" />
            </h2>
            <div className={styles.images}>
              <Swiper
                dir={dir}
                key={dir}
                modules={[Autoplay, Pagination]}
                spaceBetween={20}
                // loop
                // autoplay={{ delay: 2500, disableOnInteraction: false }}
                pagination={{ el: `.${styles["partners-pagination"]}`, clickable: true }}
                breakpoints={{
                  0: { slidesPerView: 2 },
                  576: { slidesPerView: 3 },
                  992: { slidesPerView: 5 },
                }}
              >
                {partnerPosts?.map((post, index) => {
                  return (
                    <SwiperSlide key={index} style={{paddingBlock:"20px"}} >
                      <div className={styles.partner}>
                        <Image
                          width={120}
                          height={90}
                          src={buildApiUrl(post?.data?.image)}
                          alt={`our-partner-${index}`}
                          sizes="100%"
                          layout="intrinsic"
                          loading="lazy"
                        />
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
              <div className={styles["partners-controls"]}>
                <div className={styles["partners-pagination"]} />
              </div>
            </div>
          </Container>
        </section>
      )}
      <PriceList data={pricesData} />
      <Carousel
        footerLinks={data?.footerLinks}
        posts={data?.sliderData?.[0]?.categories?.[0]?.posts || []}
      />

      <BackgroundImageWithTextButtonRightImageLeft
        primaryText={
          lang === "ar" ? indexData?.RedTitle : indexData?.RedTitle_EN
        }
        secondaryText={
          lang === "ar" ? indexData?.RedDesc : indexData?.RedDesc_EN
        }
        footerLinks={data?.footerLinks}
      />
      {/* <Testmonials testmonialsData={testmonialsData} /> */}

      <section
        className={styles["white-background"]}
        style={{ backgroundImage: `url(${forthBg.src})` }}
        dir={lang === "ar" ? "rtl" : "ltr"}
      >
        <Container>
          {benfitDataPosts?.map((post, index) => {
            const ctaUrl = normalizeSettingValue(post?.data?.ctaUrl);
            const ctaText = post?.data?.cta?.[lang];
            const isExternal = /^https?:\/\//i.test(ctaUrl);

            return (
              <Row key={index} className="align-items-center gy-5">
                
                <Col lg={7} xs={12}>
                  <div className={styles["white-background__image-box"]}>
                    <div className={styles["image-wrapper"]}>
                      <Image
                        src={buildApiUrl(post?.data?.bannerImage)}
                        alt={post?.data?.title?.[lang] || "benefit-image"}
                        width={600}
                        height={400}
                        layout="responsive"
                        objectFit="cover"
                      />
                    </div>
                  </div>
                </Col>
                <Col lg={5} xs={12}>
                  <div className={styles["white-background__text"]}>
                    <h2
                      dangerouslySetInnerHTML={{
                        __html: post?.data?.title?.[lang] || "",
                      }}
                    />
                    <h3
                      dangerouslySetInnerHTML={{
                        __html: post?.data?.subtitle?.[lang] || "",
                      }}
                    />
                    <div
                      className={styles.description}
                      dangerouslySetInnerHTML={{
                        __html: post?.data?.description?.[lang] || "",
                      }}
                    />
                    {ctaText && ctaUrl && (
                      <div className="mt-4">
                        {isExternal ? (
                          <a
                            href={ctaUrl}
                            target="_blank"
                            rel="noreferrer"
                            className={styles["cta-button-red"]}
                          >
                            
                            {ctaText}
                            <div className={styles["icon-circle"]}>
                              <svg
                                style={{
                                  transform: isRtl ? "none" : "scaleX(-1)",
                                }}
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.53577 3.53556L14.1424 14.1422"
                                  stroke="black"
                                  strokeWidth={1.5}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553"
                                  stroke="black"
                                  strokeWidth={1.5}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                          </a>
                        ) : (
                          <Link href={ctaUrl} passHref>
                            <a className={styles["cta-button-red"]}>
                              <div className={styles["icon-circle"]}>
                                <svg
                                  style={{
                                    transform: isRtl ? "none" : "scaleX(-1)",
                                  }}
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M3.53577 3.53556L14.1424 14.1422"
                                    stroke="black"
                                    strokeWidth={1.5}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553"
                                    stroke="black"
                                    strokeWidth={1.5}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                              {ctaText}
                            </a>
                          </Link>
                        )}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            );
          })}
        </Container>
      </section>

      {/* <BackgroundImageWithRightTextLeftButton
        backgroundPath={WhiteBackground.src}
        primaryText={
          lang === "ar" ? indexData?.whiteTitle : indexData?.whiteTitle_EN
        }
        secondaryText={
          lang === "ar" ? indexData?.whiteDesc : indexData?.whiteDesc_EN
        }
        data={data?.footerLinks}
      /> */}
      {certificationsItems?.length > 0 && (
        <section
          className={styles["certifications-section"]}
          dir={lang === "ar" ? "rtl" : "ltr"}
        >
          <Container>
            <h2 className={styles["certifications-title"]}>
              {certificationsTitle}
            </h2>
            <div className={styles["certifications-track"]}>
              <Swiper
                dir={lang === "ar" ? "rtl" : "ltr"}
                key={lang}
                className={styles["certifications-swiper"]}
                modules={[Pagination]}
                spaceBetween={16}
                pagination={{
                  el: `.${styles["certifications-pagination"]}`,
                  clickable: true,
                }}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  620: { slidesPerView: 2 },
                  990: { slidesPerView: 3 },
                }}
              >
                {certificationsItems.map((item, index) => {
                  const value = item?.value?.[lang];
                  const image = item?.image;
                  return (
                    <SwiperSlide
                      key={`${item?.name?.[lang] || "certification"}-${index}`}
                    >
                      <div
                        className={`${styles["certification-card"]} ${
                          image ? styles["certification-card--with-image"] : ""
                        }`}
                        style={
                          image
                            ? { backgroundImage: `url(${buildApiUrl(image)})` }
                            : undefined
                        }
                        role={image ? "button" : undefined}
                        tabIndex={image ? 0 : undefined}
                        onClick={
                          image
                            ? () => setLightboxImage(buildApiUrl(image))
                            : undefined
                        }
                        onKeyDown={
                          image
                            ? (e) => {
                                if (e.key === "Enter")
                                  setLightboxImage(buildApiUrl(image));
                              }
                            : undefined
                        }
                      >
                        <div className={styles["certification-card__content"]}>
                          <h3>{item?.name?.[lang]}</h3>
                          {value && <p>{value}</p>}
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
              <div className={styles["certifications-controls"]}>
                <div className={styles["certifications-pagination"]} />
              </div>
            </div>
          </Container>
        </section>
      )}

      <Modal
        show={Boolean(lightboxImage)}
        onHide={() => setLightboxImage(null)}
        centered
        className={styles["certification-lightbox"]}
      >
        {lightboxImage && (
          <div className={styles["certification-lightbox__frame"]}>
            <button
              type="button"
              className={styles["certification-lightbox__close"]}
              aria-label="close"
              onClick={() => setLightboxImage(null)}
            >
              <span style={{marginBottom:"2px"}}>×</span>
            </button>
            <img src={lightboxImage} alt="certification" />
          </div>
        )}
      </Modal>
      <CommonQuestions
        commonQuestionsBackgroundImage={commonQuestionsBackgroundImage}
        filteredQuestions={filteredQuestions}
      />

      

      <section className={styles["home-contact"]}  >
        <Container>
          <Row
            className={`${styles["home-contact__row"]} ${
              !hasContactVisual ? styles["home-contact__row--centered"] : ""
            }`}
          >
            <Col
              lg={hasContactVisual ? 7 : 8}
              xs={12}
              className={styles["home-contact__form-col"]}
            >
              <Form />
            </Col>
            {hasContactMap ? (
              <Col lg={5} xs={12} className={styles["home-contact__visual-col"]}>
                <div className={"contact-map"}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: contactMapHtml,
                    }}
                  />
                </div>
              </Col>
            ) : hasContactFallbackImage ? (
              <Col  className={styles["home-contact__visual-col"]}>
                <div className={"contact-map"}>
                  <img
                    src={buildApiUrl(contactFallbackImage)}
                    alt={lang === "ar" ? "صورة الموقع" : "Location"}
                  />
                </div>
              </Col>
            ) : null}
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};

export default HomePage;
